import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-attributes-health',
  templateUrl: './attributes-health.component.html',
  styleUrls: ['./attributes-health.component.css']
})
export class AttributesHealthComponent implements OnInit {

  @Input() entityData;

  constructor() { }

  ngOnInit(): void {
  }

}
